import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function archivedReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.ARCHIVED_RECORDS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReading: true, archived: [], counts: initialState.counts };
        case getNamedAction(ACTION_NAMES.ARCHIVED_RECORDS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReading: false, archived: (action.data.data || []), counts: action.data.counts };
        case getNamedAction(ACTION_NAMES.ARCHIVED_RECORDS, CRUD_ACTION_TYPES.READ_FAILURE):
            return {
                ...state, isReading: false, counts: initialState.counts
            };

        case getNamedAction(ACTION_NAMES.ARCHIVE_USERS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingArchiveUsers: true, archiveUsers: [] };
        case getNamedAction(ACTION_NAMES.ARCHIVE_USERS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingArchiveUsers: false, archiveUsers: (action.data || []) };
        case getNamedAction(ACTION_NAMES.ARCHIVE_USERS, CRUD_ACTION_TYPES.READ_FAILURE):
            return {
                ...state, isReadingArchiveUsers: false
            };
        default:
            return state;
    }
}


export default archivedReducer;
